import actions from '../../actionTypes';

export default () => {
  return {
    type: actions.RESET_STATUS_DETAIL
  };
};



// WEBPACK FOOTER //
// ./src/reducers/status/actions/resetStatusDetails.js